import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

export interface IWorkerEditRequestAction {
  data: {
    all_interventions: boolean;
    company_details: boolean;
    email: string;
    firstName?: string;
    id: number;
    invoice_permission: boolean;
    lastName?: string;
    locale: string;
    // teamId: number;
    userType?: string;
    user_management: boolean;
  };
  functions: {
    error: (err: any) => void;
    handleClose: () => void;
  };
}

function editRequest(
  draft: Draft<IWorkerData>,
  _: PayloadAction<IWorkerEditRequestAction>,
) {
  draft.edit.config.isLoading = true;
}

export default editRequest;
